<template>
  <div>
    <router-link class="come-back" to="/admin/subject">
      <div></div>
      Вернуться назад
    </router-link>

    <h2 class="title_categories">
      {{ isEdit ? `Редактирование субъекта №${$route.params.id}` : 'Создание субъекта' }}
    </h2>
    <tricolor-line class="card_containet__tricolor"/>

    <form @submit.prevent="createSubject" ref="createSubject">
        <div class="content-sb">
          <p>Заголовок<span>*</span></p>
          <input required placeholder="Введите заголовок" v-model="subjectData.title" type="text" name="title" class="input blue">
        </div>

        <div class="content-sb">
          <p>Федеральный округ<span>*</span></p>
          <select name="federal_district" v-model="subjectData.federalDistrict" class="input blue">
            <option v-for="(federalDistrict,index) in getFederalDistrict" :value="federalDistrict.id" :key="`federalDistrict${index}`">
              {{ federalDistrict.title }}
            </option>
          </select>
        </div>

      <footer class="content-sb btns-create-form">
        <router-link to="/admin/subject" class="btn-white">Отмена</router-link>
        <input type="submit" class="btn-blue" value="Сохранить"/>
      </footer>
    </form>
  </div>
</template>

<script>
import TricolorLine from '@/components/TricolorLine'

export default {
  name: 'CreateSubject',

  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      previewBlob: null,
      subjectData: {
        title: null,
        federalDistrict: 1
      }
    }
  },

  watch: {
    '$store.getters.getDetailedSubject' () {
      const dataFromServer = this.$store.getters.getDetailedSubject

      this.subjectData = {
        title: dataFromServer.title,
        federalDistrict: dataFromServer.federal_district
      }
    }
  },

  created () {
    if (this.isEdit) {
      this.$store.dispatch('setDetailedSubject', this.$route.params.id)
    }
    this.$store.dispatch('setStatusInfoNko')
  },

  methods: {
    createSubject () {
      const formData = new FormData()
      formData.append('title', this.subjectData.title)
      formData.append('federal_district', this.subjectData.federalDistrict)

      if (!this.isEdit) {
        this.$store.dispatch('createSubject', formData)
      } else {
        formData.append('_method', 'PUT')
        this.$store.dispatch('editSubject', {
          data: formData,
          id: this.$route.params.id
        })
      }
    }
  },

  computed: {
    getFederalDistrict () {
      return this.$store.getters.getStatusInfoNko
    }
  },

  components: {
    TricolorLine
  }
}
</script>

<style scoped lang="scss">
  @import "../../../assets/scss/utils/vars";

  .wysiwyg {
    width: 33.75rem;
  }

  .contacts__block {
    border-bottom: 1px solid #D5D6D9;
    margin-bottom: 1rem;

    header {
      margin-bottom: .75rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > h4 {
        font-size: .875rem;
        line-height: 1.375rem;
      }

      > img {
        width: 1.5rem;
        height: 1.5rem;
        object-fit: contain;
        object-position: center;
        cursor: pointer;
      }
    }
  }

  .btns-create-form {
    border-top: 1px solid #D5D6D9;
    padding-top: 2.5rem;
    margin-top: 2.5rem;
  }

  .content-sb {
    margin-bottom: 1.25rem;

    span {
      color: red;
    }
  }

  .select, .input {
    width: 33.75rem;
  }

  .inputs__container {
    margin-bottom: 2rem;
    border-bottom: 1px solid #D5D6D9;
  }

  .content-blocks__container {
    display: flex;
    flex-direction: column;

    > .content-block {
      margin-bottom: 1.875rem;

      header {
        margin-bottom: .75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > h4 {
          font-size: .875rem;
          line-height: 1.375rem;
          color: $mainFontColor;
        }

        > img {
          width: 1.5rem;
          height: 1.5rem;
          object-fit: contain;
          object-position: center;
          cursor: pointer;
        }
      }

      .data-card {
        background: white;
        border: 1px solid #EBF3FF;
        box-sizing: border-box;
        box-shadow: 0 .9375rem 1.5625rem rgba(189, 205, 221, 0.15);
        border-radius: .5rem;
        padding: 1.25rem;
        width: 100%;
        min-height: 8.875rem;
      }
    }
  }

  .add-content-block__container {
    background-color: $neutral-placeholder;
    width: 100%;
    padding: 1.25rem;
    border-radius: .187rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: .5rem;

    &:after {
      content: '';
      position: absolute;
      width: 1.5rem;
      height: 1.5rem;
      background-color: $neutral-placeholder;
      top: 0;
      left: 50%;
      transform: translate(-50%,-50%) rotate(45deg);
    }

    > .row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.25rem;
    }

    > .btn-blue > img {
      width: 1.125rem;
      height: 1.125rem;
      object-fit: contain;
      object-position: center;
      margin-right: .5rem;
    }
  }
</style>
